// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as CTABar$Showside from "./CTABar.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as VideoJS$Showside from "../utils/VideoJS.bs.js";
import * as Previous$Showside from "../utils/Previous.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as ReactDOMUtils$Showside from "../utils/ReactDOMUtils.bs.js";
import * as ExpandSequence$Showside from "../utils/ExpandSequence.bs.js";
import * as QuickViewTypes$Showside from "../types/QuickViewTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as UseIdleCallback$Showside from "../hook/UseIdleCallback.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as QuickViewMediaBox$Showside from "./QuickViewMediaBox.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ProductDetailsPage_Lazy$Showside from "../pages/ProductDetailsPage_Lazy.bs.js";
function QuickView(Props) {
  var config = Props.config;
  var getSourceEl = Props.getSourceEl;
  var renderMedia = Props.renderMedia;
  var renderMediaBackdrop = Props.renderMediaBackdrop;
  var primaryButtonLabel = Props.primaryButtonLabel;
  var primaryButtonConfirmation = Props.primaryButtonConfirmation;
  var primaryButtonStyle = Props.primaryButtonStyle;
  var secondaryButtonLabel = Props.secondaryButtonLabel;
  var secondaryButtonConfirmation = Props.secondaryButtonConfirmation;
  var layoutOpt = Props.layout;
  var columnsOpt = Props.columns;
  var onClickPrimaryButton = Props.onClickPrimaryButton;
  var onClickSecondaryButton = Props.onClickSecondaryButton;
  var onIntroStartOpt = Props.onIntroStart;
  var onIntroCompleteOpt = Props.onIntroComplete;
  var onExitCompleteOpt = Props.onExitComplete;
  var getProductListButtonLabel = Props.getProductListButtonLabel;
  var productListButtonStyle = Props.productListButtonStyle;
  var onClickProductListButton = Props.onClickProductListButton;
  var showMoreProducts = Props.showMoreProducts;
  var layout = layoutOpt !== undefined ? layoutOpt : /* ThreeColumnLayout */1;
  var columns = columnsOpt !== undefined ? columnsOpt : /* TwoColumnGrid */1;
  var onIntroStart = onIntroStartOpt !== undefined ? onIntroStartOpt : function (el, media) {};
  var onIntroComplete = onIntroCompleteOpt !== undefined ? onIntroCompleteOpt : function (el, media) {};
  var onExitComplete = onExitCompleteOpt !== undefined ? onExitCompleteOpt : function (param) {};
  var requestIdleCallback = UseIdleCallback$Showside.useIdleCallback(undefined, undefined);
  var match = ViewportContext$Showside.use(undefined);
  var isMobile = match.isMobile;
  var routeContent = RouterProvider$Showside.useRouter(undefined);
  var goTo = routeContent.goTo;
  var quickViewUnderlyingRoute = routeContent.quickViewUnderlyingRoute;
  var route = routeContent.route;
  var entrypointCtx = EntrypointContext$Showside.use(undefined);
  var productId;
  productId = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.productId;
  var viewport = React.useRef(null);
  var scrollableRef = React.useRef(null);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var settings = match$1.config.settings;
  Curry._1(requestIdleCallback, ProductDetailsPage_Lazy$Showside.preload);
  var modifiedTrackEvent = React.useCallback(function ($$event) {
    return function (shouldTrackConfigDTOOpt, category, product, variant, toProduct, time, isMiniPDPVisibleOpt, mediaId, mediaParentId, mediaSrc, mediaTitle, relatedMediaCategoryId, relatedMediaProductIds, url, param) {
      var shouldTrackConfigDTO = shouldTrackConfigDTOOpt !== undefined ? shouldTrackConfigDTOOpt : false;
      var isMiniPDPVisible = isMiniPDPVisibleOpt !== undefined ? isMiniPDPVisibleOpt : false;
      var tmp;
      tmp = typeof route === "number" || route.TAG !== /* QuickView */3 ? mediaId : route._0.mediaId;
      var tmp$1;
      tmp$1 = typeof route === "number" || route.TAG !== /* QuickView */3 ? mediaParentId : route._0.mediaParentId;
      var tmp$2;
      if (typeof route === "number" || route.TAG !== /* QuickView */3) {
        tmp$2 = mediaSrc;
      } else {
        var mediaId$1 = route._0.mediaId;
        tmp$2 = Belt_Option.map(Belt_Array.getBy(config.media, function (m) {
          return m.id === mediaId$1;
        }), function (m) {
          return Belt_Option.getWithDefault(m.fallbackImageUrl, m.src);
        });
      }
      var tmp$3;
      if (typeof route === "number" || route.TAG !== /* QuickView */3) {
        tmp$3 = mediaTitle;
      } else {
        var mediaId$2 = route._0.mediaId;
        tmp$3 = Belt_Option.flatMap(Belt_Array.getBy(config.media, function (m) {
          return m.id === mediaId$2;
        }), function (m) {
          return m.title;
        });
      }
      var tmp$4;
      tmp$4 = typeof route === "number" || route.TAG !== /* QuickView */3 ? relatedMediaCategoryId : route._0.relatedMediaCategoryId;
      var tmp$5;
      tmp$5 = typeof route === "number" || route.TAG !== /* QuickView */3 ? relatedMediaProductIds : Belt_Option.map(route._0.relatedMediaProductIds, function (ids) {
        return ids.join(",");
      });
      return Curry.app(entrypointCtx.trackEvent, [$$event, shouldTrackConfigDTO, category, product, variant, toProduct, time, isMiniPDPVisible, tmp, tmp$1, tmp$2, tmp$3, tmp$4, tmp$5, url, undefined]);
    };
  }, [entrypointCtx.trackEvent, RouterProvider$Showside.toString(route)]);
  var categoryId = Belt_Option.mapWithDefault(routeContent.listPageType, "", function (id) {
    if (typeof id === "number" || id.TAG !== /* Category */0) {
      return "";
    } else {
      return id._0;
    }
  });
  var isOpen;
  isOpen = typeof route === "number" || route.TAG !== /* QuickView */3 ? false : true;
  var isInitialMount = React.useRef(true);
  React.useEffect(function () {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      if (isOpen) {
        Curry.app(modifiedTrackEvent, ["Opened", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      }
      if (!isOpen) {
        Curry.app(modifiedTrackEvent, ["Closed", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      }
    }
  }, [isOpen]);
  var pdpScrollToTop = React.useRef(function (param) {});
  var panelClosed;
  panelClosed = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.panelClosed;
  var panelClosed$1 = Belt_Option.getWithDefault(panelClosed, false);
  var previousDistinctLocation = Previous$Showside.usePreviousDistinct(route);
  var previousDistinctLocation$1 = Caml_obj.equal(route, previousDistinctLocation) ? {
    TAG: /* QuickView */3,
    _0: {
      mediaId: "",
      mediaParentId: undefined,
      albumId: undefined,
      productId: undefined,
      relatedMediaProductIds: undefined,
      relatedMediaCategoryId: undefined,
      variantId: undefined,
      panelClosed: undefined,
      zoomedPhotoIndex: undefined,
      time: undefined
    }
  } : previousDistinctLocation;
  var match$2 = React.useState(function () {
    return [];
  });
  var setReadyMeady = match$2[1];
  var readyMedia = match$2[0];
  var getVideo = function (media) {
    return Belt_Option.flatMap(Curry._1(getSourceEl, media), function (el) {
      return Caml_option.nullable_to_opt(el.querySelector("video, maker-video"));
    });
  };
  var getPlayer = function (media) {
    return Belt_Option.flatMap(getVideo(media), VideoJS$Showside.getPlayer);
  };
  var getSourceVideoTime = function (media) {
    var vid = getPlayer(media);
    if (vid !== undefined) {
      return Caml_option.valFromOption(vid).currentTime();
    } else {
      return 0.0;
    }
  };
  var setSourceVideoTime = function (media, t) {
    var vid = getPlayer(media);
    if (vid !== undefined) {
      Caml_option.valFromOption(vid).currentTime(t);
      return;
    }
  };
  var close = function (param) {
    Curry._3(goTo, undefined, undefined, quickViewUnderlyingRoute !== undefined ? quickViewUnderlyingRoute : /* NotRendered */0);
  };
  var renderMediaBlurBackdrop = function (media) {
    var background = Curry._1(renderMediaBackdrop, media);
    var match = config.carousel;
    var tmp;
    var exit = 0;
    if (match && !isMobile) {
      tmp = null;
    } else {
      exit = 1;
    }
    if (exit === 1) {
      tmp = React.createElement("div", {
        className: CSS$Showside.prefix("absolute inset-0")
      }, background);
    }
    return React.createElement("div", {
      className: CSS$Showside.prefix("absolute inset-0")
    }, tmp, React.createElement("div", {
      className: CSS$Showside.prefix(Cn.make(["absolute inset-0", isMobile ? "overlay-light" : "overlay"]))
    }));
  };
  var pausedVideos = React.useRef([]);
  var pauseAllSourceVideos = function (param) {
    var videos = Belt_Array.keep(config.media, function (m) {
      return m.kind === "video";
    });
    var playing = Belt_Array.keep(videos, function (media) {
      var el = getVideo(media);
      var paused = Belt_Option.flatMap(el, function (prim) {
        return prim.paused;
      });
      if (paused !== undefined) {
        return paused === false;
      } else {
        return false;
      }
    });
    Belt_Array.forEach(playing, function (media) {
      var vid = getPlayer(media);
      if (vid !== undefined) {
        Caml_option.valFromOption(vid).pause();
        return;
      }
    });
    pausedVideos.current = playing;
  };
  var resumeAllPausedVideos = function (param) {
    Belt_Array.forEach(pausedVideos.current, function (media) {
      var vid = getPlayer(media);
      if (vid !== undefined) {
        Caml_option.valFromOption(vid).play();
        return;
      }
    });
  };
  var getProductImageSourceEl = function (containerSelector, productId) {
    var productImgSrc = Belt_Option.flatMap(Product$Showside.getProductById(config.products, productId), function (product) {
      return Belt_Array.get(Product$Showside.getValidProductImages(product), 0);
    });
    return Belt_Array.get(Belt_Option.getWithDefault(Belt_Option.map(Caml_option.nullable_to_opt(document.querySelector(containerSelector)), function (container) {
      return Belt_Array.keep(Array.prototype.slice.call(container.getElementsByTagName("img")), function (el) {
        var originalSrc = el.getAttribute("data-original-src");
        var originalSrc$1 = originalSrc == null ? undefined : Caml_option.some(originalSrc);
        if (originalSrc$1 === productImgSrc) {
          return originalSrc$1 !== undefined;
        } else {
          return false;
        }
      });
    }), []), 0);
  };
  var getSourceObjectFit = function (media) {
    return Belt_Option.flatMap(Curry._1(getSourceEl, media), function (sourceEl) {
      if (Belt_Option.flatMap(Caml_option.nullable_to_opt(sourceEl.querySelector("[data-fit-to-container]")), function (objectFitRuleEl) {
        return Caml_option.nullable_to_opt(objectFitRuleEl.getAttribute("data-fit-to-container"));
      }) === "true") {
        return "contain";
      } else {
        return "cover";
      }
    });
  };
  var stopTouchPropagation = function (e) {
    e.stopPropagation();
  };
  var determineTransition = function (prev, next) {
    var match = prev.mediaId !== "";
    var match$1 = next.mediaId !== "";
    var match$2 = prev.productId !== undefined;
    var match$3 = next.productId !== undefined;
    if (match) {
      if (match$1) {
        if (match$2) {
          if (match$3) {
            return /* FromPDPToPDP */3;
          } else {
            return /* FromPDPToMedia */4;
          }
        } else if (match$3) {
          return /* FromMediaToPDP */6;
        } else {
          return /* FromMediaToMedia */8;
        }
      } else if (match$2) {
        if (match$3) {
          return /* FromNoneToNone */0;
        } else {
          return /* FromPDPToNone */5;
        }
      } else if (match$3) {
        return /* FromNoneToNone */0;
      } else {
        return /* FromMediaToNone */7;
      }
    } else if (match$1 && !match$2) {
      if (match$3) {
        return /* FromNoneToPDP */2;
      } else {
        return /* FromNoneToMedia */1;
      }
    } else {
      return /* FromNoneToNone */0;
    }
  };
  var transition;
  var exit = 0;
  var exit$1 = 0;
  if (typeof previousDistinctLocation$1 === "number" || previousDistinctLocation$1.TAG !== /* QuickView */3) {
    exit$1 = 2;
  } else if (typeof route === "number" || route.TAG !== /* QuickView */3) {
    exit = 1;
  } else {
    transition = determineTransition(previousDistinctLocation$1._0, route._0);
  }
  if (exit$1 === 2) {
    if (typeof route === "number" || route.TAG !== /* QuickView */3) {
      exit = 1;
    } else {
      transition = determineTransition({
        mediaId: "",
        mediaParentId: undefined,
        albumId: undefined,
        productId: undefined,
        relatedMediaProductIds: undefined,
        relatedMediaCategoryId: undefined,
        variantId: undefined,
        panelClosed: undefined,
        zoomedPhotoIndex: undefined,
        time: undefined
      }, route._0);
    }
  }
  if (exit === 1) {
    transition = typeof previousDistinctLocation$1 === "number" || previousDistinctLocation$1.TAG !== /* QuickView */3 ? /* FromNoneToNone */0 : determineTransition(previousDistinctLocation$1._0, {
      mediaId: "",
      mediaParentId: undefined,
      albumId: undefined,
      productId: undefined,
      relatedMediaProductIds: undefined,
      relatedMediaCategoryId: undefined,
      variantId: undefined,
      panelClosed: undefined,
      zoomedPhotoIndex: undefined,
      time: undefined
    });
  }
  var maybeRenderMediaScreen = function (route, isOpen, animate, onPhaseChange) {
    if (typeof route === "number") {
      return null;
    }
    if (route.TAG !== /* QuickView */3) {
      return null;
    }
    var media = QuickViewTypes$Showside.mediaById(config, route._0.mediaId);
    if (media !== undefined) {
      return React.createElement(ExpandSequence$Showside.make, {
        isOpen: isOpen,
        animate: animate && Belt_Option.isSome(Curry._1(getSourceEl, media)),
        getSourceEl: function (param) {
          return Curry._1(getSourceEl, media);
        },
        allowPhaseChange: function (transition) {
          var match = transition.previousPhase;
          var match$1 = transition.phase;
          if (typeof match === "number" || match$1 !== 1) {
            return true;
          } else {
            return readyMedia.includes(media.id);
          }
        },
        onPhaseChange: onPhaseChange,
        onTouchEnd: stopTouchPropagation,
        onTouchStart: stopTouchPropagation,
        onTouchMove: stopTouchPropagation,
        renderForeground: function (param, param$1) {
          var fit = Belt_Option.getWithDefault(typeof param === "number" ? undefined : getSourceObjectFit(media), "scale-down");
          var tmp = {
            viewport: viewport,
            phase: param,
            duration: param$1,
            renderMedia: renderMedia,
            media: media,
            config: config,
            objectFit: fit,
            getSourceVideoTime: getSourceVideoTime,
            setSourceVideoTime: setSourceVideoTime,
            layout: layout,
            columns: columns,
            onClose: close,
            onInitialMediaReady: function (param) {
              var mediaId = media.id;
              if (!readyMedia.includes(mediaId)) {
                return Curry._1(setReadyMeady, function (ready) {
                  return Belt_Array.concat([mediaId], ready);
                });
              }
            }
          };
          if (getProductListButtonLabel !== undefined) {
            tmp.getProductListButtonLabel = Caml_option.valFromOption(getProductListButtonLabel);
          }
          if (productListButtonStyle !== undefined) {
            tmp.productListButtonStyle = Caml_option.valFromOption(productListButtonStyle);
          }
          if (onClickProductListButton !== undefined) {
            tmp.onClickProductListButton = Caml_option.valFromOption(onClickProductListButton);
          }
          if (showMoreProducts !== undefined) {
            tmp.showMoreProducts = Caml_option.valFromOption(showMoreProducts);
          }
          return React.createElement(React.Fragment, undefined, renderMediaBlurBackdrop(media), React.createElement(QuickViewMediaBox$Showside.make, tmp));
        },
        autoHideSourceEl: false,
        zIndex: String(CSS$Showside.safeIncrementZIndex(settings.zIndexInt)),
        key: "media-screen"
      });
    } else {
      return null;
    }
  };
  var maybeRenderPDPScreen = function (autoHideSourceElOpt, noMediaBoxOpt, route, isOpen, animate, getSourceEl, onPhaseChange) {
    var autoHideSourceEl = autoHideSourceElOpt !== undefined ? autoHideSourceElOpt : true;
    var noMediaBox = noMediaBoxOpt !== undefined ? noMediaBoxOpt : false;
    var media = QuickViewTypes$Showside.mediaById(config, categoryId);
    if (media !== undefined && productId !== undefined) {
      var autoHideSourceElOpt$1 = autoHideSourceEl;
      var noMediaBoxOpt$1 = noMediaBox;
      var autoHideSourceEl$1 = autoHideSourceElOpt$1 !== undefined ? autoHideSourceElOpt$1 : true;
      var noMediaBox$1 = noMediaBoxOpt$1 !== undefined ? noMediaBoxOpt$1 : false;
      var getSourceEl$1 = function (param) {
        return Curry._1(getSourceEl, productId);
      };
      return React.createElement(ExpandSequence$Showside.make, {
        isOpen: isOpen,
        animate: animate && Belt_Option.isSome(Curry._1(getSourceEl, productId)),
        getSourceEl: getSourceEl$1,
        allowPhaseChange: function (transition) {
          return true;
        },
        onPhaseChange: onPhaseChange,
        renderForeground: function (phase, duration) {
          var bg = typeof phase === "number" && phase !== 0 ? "bg-white bg-opacity-100" : "bg-white bg-opacity-0";
          var durationCn = CSS$Showside.duration(duration);
          var tmp = {
            className: CSS$Showside.prefix(Cn.make(["absolute inset-0 transition-all", bg, durationCn]))
          };
          var tmp$1 = noMediaBox$1 ? Caml_option.some(ReactDOMUtils$Showside.Ref.domRef(viewport)) : undefined;
          if (tmp$1 !== undefined) {
            tmp.ref = Caml_option.valFromOption(tmp$1);
          }
          var tmp$2 = {
            viewport: viewport,
            shouldForceMobile: true,
            isInsideQuickView: true,
            quickViewConfig: config
          };
          if (showMoreProducts !== undefined) {
            tmp$2.showMoreProducts = showMoreProducts;
          }
          return React.createElement("div", tmp, React.createElement(Scrollable$Showside.make, {
            restorationId: "mobile-pdp",
            scrollToRef: pdpScrollToTop,
            children: React.createElement(ConditionalRender$Showside.When.make, {
              condition: routeContent.anyProductId !== undefined,
              children: React.createElement(ProductDetailsPage_Lazy$Showside.make, tmp$2)
            }),
            fwdRef: scrollableRef
          }));
        },
        autoHideSourceEl: autoHideSourceEl$1,
        zIndex: String(CSS$Showside.safeIncrementZIndex(settings.zIndexInt)),
        key: "pdp-screen"
      });
    } else {
      return null;
    }
  };
  var onPhaseChange = function (phaseTransition) {
    switch (transition) {
      case /* FromNoneToMedia */1:
      case /* FromNoneToPDP */2:
        var phase = phaseTransition.phase;
        var media = Belt_Option.flatMap(categoryId, function (param) {
          return QuickViewTypes$Showside.mediaById(config, param);
        });
        if (media !== undefined) {
          if (phase === /* MinimalFullscreen */1) {
            pauseAllSourceVideos(undefined);
            Curry._2(onIntroStart, Curry._1(getSourceEl, media), media);
          }
          if (phase === /* CompleteFullscreen */2) {
            return Curry._2(onIntroComplete, Curry._1(getSourceEl, media), media);
          } else {
            return;
          }
        } else {
          return;
        }
      case /* FromPDPToNone */5:
      case /* FromMediaToNone */7:
        var phase$1 = phaseTransition.phase;
        if (phase$1 === /* Hidden */0) {
          resumeAllPausedVideos(undefined);
          return Curry._1(onExitComplete, undefined);
        } else {
          return;
        }
      case /* FromNoneToNone */0:
      case /* FromPDPToPDP */3:
      case /* FromPDPToMedia */4:
      case /* FromMediaToPDP */6:
      case /* FromMediaToMedia */8:
        return;
    }
  };
  var renderScreensMobile = function (param) {
    switch (transition) {
      case /* FromNoneToNone */0:
        return null;
      case /* FromNoneToPDP */2:
        var getSourceEl$1 = function (param) {
          return Belt_Option.flatMap(QuickViewTypes$Showside.mediaById(config, categoryId), getSourceEl);
        };
        return React.createElement(React.Fragment, undefined, maybeRenderPDPScreen(false, true, route, true, true, getSourceEl$1, onPhaseChange));
      case /* FromPDPToPDP */3:
        var getSourceEl$2 = function (param) {};
        return React.createElement(React.Fragment, undefined, maybeRenderPDPScreen(undefined, true, route, true, false, getSourceEl$2, onPhaseChange));
      case /* FromPDPToMedia */4:
        var isDrawerOpen = !panelClosed$1;
        var partial_arg = isDrawerOpen ? ".QVTW__product_drawer" : ".QVTW__media_screen";
        var getSourceEl$3 = function (param) {
          return getProductImageSourceEl(partial_arg, param);
        };
        return React.createElement(React.Fragment, undefined, maybeRenderMediaScreen(route, true, false, onPhaseChange), maybeRenderPDPScreen(undefined, undefined, previousDistinctLocation$1, false, true, getSourceEl$3, onPhaseChange));
      case /* FromPDPToNone */5:
        var getSourceEl$4 = function (param) {
          return Belt_Option.flatMap(QuickViewTypes$Showside.mediaById(config, categoryId), getSourceEl);
        };
        return React.createElement(React.Fragment, undefined, maybeRenderPDPScreen(false, true, previousDistinctLocation$1, false, true, getSourceEl$4, onPhaseChange));
      case /* FromMediaToPDP */6:
        var isDrawerOpen$1 = !panelClosed$1;
        var partial_arg$1 = isDrawerOpen$1 ? ".QVTW__product_drawer" : ".QVTW__media_screen";
        var getSourceEl$5 = function (param) {
          return getProductImageSourceEl(partial_arg$1, param);
        };
        return React.createElement(React.Fragment, undefined, maybeRenderMediaScreen(route, true, true, onPhaseChange), maybeRenderPDPScreen(undefined, undefined, route, true, true, getSourceEl$5, onPhaseChange));
      case /* FromMediaToNone */7:
        return React.createElement(React.Fragment, undefined, maybeRenderMediaScreen(previousDistinctLocation$1, false, true, onPhaseChange));
      case /* FromNoneToMedia */1:
      case /* FromMediaToMedia */8:
        break;
    }
    return React.createElement(React.Fragment, undefined, maybeRenderMediaScreen(route, true, true, onPhaseChange));
  };
  var renderScreensDesktop = function (param) {
    var exit = 0;
    switch (transition) {
      case /* FromNoneToNone */0:
        return null;
      case /* FromNoneToMedia */1:
      case /* FromNoneToPDP */2:
      case /* FromPDPToPDP */3:
      case /* FromPDPToMedia */4:
      case /* FromMediaToPDP */6:
        exit = 1;
        break;
      case /* FromPDPToNone */5:
      case /* FromMediaToNone */7:
        exit = 2;
        break;
      case /* FromMediaToMedia */8:
        return React.createElement(React.Fragment, undefined, maybeRenderMediaScreen(route, true, false, onPhaseChange));
    }
    switch (exit) {
      case 1:
        return React.createElement(React.Fragment, undefined, maybeRenderMediaScreen(route, true, true, onPhaseChange));
      case 2:
        return React.createElement(React.Fragment, undefined, maybeRenderMediaScreen(previousDistinctLocation$1, false, true, onPhaseChange));
    }
  };
  var entrypointCtxValue = React.useMemo(function () {
    var newrecord = Caml_obj.obj_dup(entrypointCtx);
    newrecord.trackEvent = modifiedTrackEvent;
    return newrecord;
  }, [entrypointCtx, modifiedTrackEvent]);
  return React.createElement(EntrypointContext$Showside.Provider.make, {
    value: entrypointCtxValue,
    children: React.createElement(CTABar$Showside.OverrideContextProvider.make, {
      value: {
        primaryButtonLabel: primaryButtonLabel,
        primaryButtonStyle: primaryButtonStyle,
        primaryButtonConfirmation: primaryButtonConfirmation,
        onClickPrimaryButton: Belt_Option.map(onClickPrimaryButton, function (fn, product, variant, quantity) {
          Curry.app(modifiedTrackEvent, ["Clicked CTA Button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
          Curry._4(fn, product.id, product, variant, quantity);
        }),
        secondaryButtonLabel: secondaryButtonLabel,
        secondaryButtonConfirmation: secondaryButtonConfirmation,
        onClickSecondaryButton: Belt_Option.map(onClickSecondaryButton, function (fn, product, variant, quantity) {
          Curry.app(modifiedTrackEvent, ["Clicked Secondary Button", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
          Curry._4(fn, product.id, product, variant, quantity);
        })
      },
      children: isMobile ? renderScreensMobile(undefined) : renderScreensDesktop(undefined)
    })
  });
}
QuickView.displayName = "QuickView";
var make = QuickView;
export { make };
/* react Not a pure module */